import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 
 *
 * @param sanitizedQuery - The sanitized search query.
 * @param token - The authentication token.
 * @returns An object containing the processed addresses (addressesWithPamCode) and optional boundaryData.
 */
export async function fetchGlobalAddressesAsync(
    sanitizedQuery: string,
    token: string
  ): Promise<{ addressesWithPamCode: any[]; boundaryData?: any }> {
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(
        `${baseUrl}/api/address/SearchAddressAsync?searchData=${sanitizedQuery}`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to fetch addresses");
      }
  
      const data = await response.json();
      let addressesWithPamCode: any[] = [];
  
      if (sanitizedQuery.length === 10) {
        let tempAddresses: any[] = [];
        if (Array.isArray(data)) {
          tempAddresses = data;
        } else if (data.addresses && Array.isArray(data.addresses)) {
          tempAddresses = data.addresses;
        }
        const validAddresses = tempAddresses.filter(
          (address: any) =>
            address.addressLine1 && address.addressLine1.trim() !== ""
        );
        const validBoundary =
          data.boundaryData !== null && data.boundaryData !== undefined;
        if (validBoundary) {
          if (validAddresses.length > 0) {
            addressesWithPamCode = validAddresses.map((address: any) => ({
              ...address,
              pamCode: `${address.pinCode}-${address.blockCode}-${address.addressCode}`,
              displayText: `${address.addressLine1}: ${address.pinCode}-${address.blockCode}-${address.addressCode}`,
            }));
          } else {
            addressesWithPamCode = [];
          }
        } else {
          addressesWithPamCode = [];
        }
      } else {
        if (Array.isArray(data)) {
          addressesWithPamCode = data.map((address: any) => ({
            ...address,
            pamCode: `${address.pinCode}-${address.blockCode}-${address.addressCode}`,
            displayText: `${address.addressLine1}: ${address.pinCode}-${address.blockCode}-${address.addressCode}`,
          }));
        } else {
          addressesWithPamCode = [];
        }
      }
  
      return { addressesWithPamCode, boundaryData: data.boundaryData };
    } catch (error) {
      // console.error("Error fetching global addresses:", error);
      throw error;
    }
  }
  
  /**
   
   *
   * @param searchData - The search query.
   * @param token - The authentication token.
   * @returns The raw API response data.
   */
  export async function fetchAddressResultsAsync(
  searchData: string,
  token?: string
): Promise<any> {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/address/SearchAddressAsync?searchData=${searchData}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch address data");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
}

  